import Cookie from 'js-cookie';
import { useEffect } from 'react';

export const useCsrf = () => {
  useEffect(() => {
    if (Cookie.get('csrftoken') != null) {
      return;
    }

    fetch('/api/csrf/', {
      credentials: 'same-origin',
    }).catch(() => null);
  }, []);
};
